<template>
  <div class="protocol-container">
    <div class="protocol-header">
      <h1 class="protocol-title">遊戲服務客戶公約</h1>
    </div>

    <div class="protocol-intro">
      <p>
        本條約載明您在使用遊戲服務（以下簡稱本服務）時，應有的權利、應盡的義務及所適用的條件與條款等資料，同時記載本公司應負之責任與義務，請您務必詳細閱讀，以保障您的權益。
      </p>
      <p>
        一旦您按下同意鍵後，即表示您使用本服務時，同意並願意遵守以下所有規定；另外提醒您，此處之規定隨時可能會變更，敬請定期查詢本客服中心之公告。
      </p>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">一、認知與接受條款</h2>
      <div class="section-content">
        <p>
          您瞭解您註冊成為本網站會員後，即可使用本公司所提供之各項會員服務（以下簡稱本服務），且表示您已閱讀、瞭解並同意接受本服務條款之所有內容。
        </p>
        <p>
          為確保遊戲進行之秩序，克里奧數位行銷有限公司得訂立合理公平之遊戲使用者條約或管理規則，會員應遵守公告之遊戲使用者條約或管理規則。
        </p>
        <p>遊戲使用者條約或管理規則視為本公約之一部份，與本公約具有相同效力。</p>
        <p>
          當會員使用本服務時，即表示除了同意遵守本服務條款外，還同意接受克里奧數位行銷有限公司對本網站會員之規範（包括客服中心內容、使用者條約、管理規則、公告事項各別服務之規範等）並遵守相關法律規定。
        </p>
        <p>
          如您是未滿二十歲之無行為能力或限制行為能力人，則您必須在加入會員前，請您的法定代理人閱讀本合約書。無行為能力人應由其法定代理人代為申請本服務；限制行為能力人，應得其法定代理人之同意，方可使用本方所提供之會員服務；一旦您完成註冊並開始使用本方所提供之服務，即推定您的法定代理人已經閱讀，並了解與同意本方之各會員服務條款。
        </p>
        <p>
          您保證已審閱本協議至少三日並已充分理解了前述協議，並且同意使用克里奧數位行銷有限公司用戶使用公約，即承認您已同意受克里奧數位行銷有限公司用戶使用公約所包含條約的約束。您也瞭解和同意本協議是您和克里奧數位行銷有限公司之間，就使用克里奧數位行銷有限公司用戶使用公約的完整和唯一表述，您和克里奧數位行銷有限公司之間的任何事先或即時的以口頭或書面或其他交流方式形成的約定都應為本公約所取代。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">二、用戶服務條款之增訂及修改</h2>
      <div class="section-content">
        <p>
          克里奧數位行銷有限公司保留增訂及修改本用戶條款及各項案件處理中心服務條約之權利，本條款如有增訂或修改時，克里奧數位行銷有限公司將於服務平台公告修改之事實，對用戶不另作個別通知。如您不同意修改的內容，請勿繼續使用本服務，如果您於公告後繼續使用本服務，則視為您已接受並同意該修訂條款。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">三、服務介紹</h2>
      <div class="section-content">
        <p>
          本服務是克里奧數位行銷有限公司提供的遊戲平台，您將可享受各種符合本網站所提供的包含遊戲等各項服務，未來本網站將與其他廠商合作，陸續提供更多其他網路服務供用戶使用。
        </p>
        <p>接受本服務之用戶必須自行配備上網所需之各項電腦設備，以及負擔「網際網路連線費用」、「電話費用」等之電信相關費用。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">四、用戶責任與義務</h2>
      <div class="section-content">
        <div class="sub-section">
          <h3 class="sub-title">(一) 真實登錄義務</h3>
          <p>
            您同意於使用本服務時登錄您本人正確、完整且符合真實之個人資料（包括真實姓名、身分證字號及E-Mail等）。您所登錄之資料若事後有所變更時，應隨時使用克里奧數位行銷有限公司所提供之更新方式更新。當所登錄的個人資料，或原登錄之資料已不符合真實而未更新，或有任何誤導之嫌，克里奧數位行銷有限公司將保留隨時終止您用戶資格及使用本服務之權利。此外，若您以虛偽不正之方式進行交易，本公司也將保留隨時終止您用戶資格及使用各項服務之權利（例如停止或刪除您於本服務平台之帳號）。
          </p>
        </div>

        <div class="sub-section">
          <h3 class="sub-title">(二) 服務使用之責任與義務</h3>
          <ol class="numbered-list">
            <li>用戶不得利用本服務進行任何商業行為，如濫發廣告郵件、宣傳性商業網站等。</li>
            <li>除了遵守本服務條款外，您同意遵守網際網路國際使用慣例與禮節之相關規定。</li>
            <li>用戶不得利用本服務傳送、發表涉及辱罵、毀謗、不雅、淫穢、攻擊性之文章或圖片。</li>
            <li>用戶同意必須充分尊重智慧財產權，禁止發表侵害他人各項智慧財產權或其他權利之文字、圖片或任何形式之檔案。</li>
          </ol>
        </div>

        <div class="sub-section">
          <h3 class="sub-title">(三) 帳號保管義務</h3>
          <ol class="numbered-list">
            <li>
              您暸解當您成為本服務平台用戶後得開始使用本服務，其所有權仍屬克里奧數位行銷有限公司及其所約定之人所有，用戶僅得依本服務條款之約定使用，不得出租、出借、移轉或讓與給其他之三人使用。
            </li>
            <li>用戶有義務妥善保管登入本服務平台帳號、密碼及其他相關之用戶資料，並為此組帳號登入系統後所進行之一切活動、行為負責。</li>
            <li>
              若用戶發現帳號或密碼遭人非法使用或有任何異常破壞使用安全之情形時，應立即通知克里奧數位行銷有限公司。但若是因您的保管疏忽，而導致帳號、密碼遭他人非法使用時，克里奧數位行銷有限公司將不負責處理。
            </li>
          </ol>
        </div>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">五、用戶責任限制</h2>
      <div class="section-content">
        <p>若您使用虛偽不正之方式進行「儲值」，克里奧數位行銷有限公司保留隨時終止您用戶資格及使用本服務之權利，並將追究相關法律責任。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">六、服務之終止與變更</h2>
      <div class="section-content">
        <p>
          用戶於各服務申請上若有下列任一情形時，克里奧數位行銷有限公司有權隨時終止或變更任一用戶帳號之服務，且無需事先通知用戶。就終止或更改用戶使用本服務所可能產生之困擾、不便或損害，本服務對任何用戶或第三人均不負任何責任。
        </p>
        <ol class="numbered-list">
          <li>用戶登錄不實資料進行註冊。</li>
          <li>以克里奧數位行銷有限公司或類似克里奧數位行銷有限公司名稱使用本服務者。</li>
          <li>使用中文、英文及數字以外之字元及不雅文字作為本服務之名稱。</li>
          <li>冒用他人名義申請本服務之帳號。</li>
          <li>使用虛偽不正之方式進行儲值。</li>
          <li>違反本服務條款時。</li>
          <li>違反公共安全、公共秩序與善良風俗之行為時。</li>
          <li>違反現行法律之行為時。</li>
        </ol>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">七、服務暫停或中斷</h2>
      <div class="section-content">
        <p>
          於下列情形任一情形發生時，克里奧數位行銷有限公司有權暫停或中斷本服務之全部或一部，對因此而產生之困擾、不便或損害，本服務對任何用戶或第三人均不負任何責任。
        </p>
        <ol class="numbered-list">
          <li>對本服務之相關軟硬體設備與電子通信設備進行維修保養及施工時。</li>
          <li>發生突發性之軟硬體設備與電子通信設備故障時。</li>
          <li>因天災等不可抗力之因素致使本服務無法提供服務時。</li>
          <li>在緊急情況下為維護其他用戶或第三人的人身、資料之完整安全。</li>
        </ol>
        <p>
          如因使用者違反法令或本服務條款或因不可歸責於克里奧數位行銷有限公司之事由而造成本服務之全部或一部暫停或中斷時，暫停或中斷期間之費用仍依正常標準計費。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">八、服務變更權利</h2>
      <div class="section-content">
        <p>克里奧數位行銷有限公司將保留新增、修改或刪除本服務之全部或一部之權利，且不另行個別通知，用戶不得因此而要求任何補償或賠償。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">九、責任範圍</h2>
      <div class="section-content">
        <ol class="numbered-list">
          <li>
            本服務依克里奧數位行銷有限公司既有之規劃提供對於特定使用者之特殊需求，克里奧數位行銷有限公司不擔保本服務將完全符合您的需求。
          </li>
          <li>
            本服務可能因自身、其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈；或人為操作上之疏失而造成中斷、暫時無法使用、遲延、資料傳輸或儲存上之錯誤；或遭第三人侵入系統篡改或偽造變造資料等。克里奧數位行銷有限公司就以上情形不保證各項服務之穩定、安全、無誤、及不中斷。用戶需明白使用本服務之所有風險及可能致生之任何損害，不得因此而要求任何補償或賠償。
          </li>
          <li>
            請詳閱本約內容及各項服務注意事項，若您不接受任一服務內容請立即退出且拒絕申請案件處理中心服務。用戶申請各服務時，申請人必需詳實填寫與您身份證相符合之資料，若因上述資料不實而造成無法通知所致之損失，將由使用者自行承擔。申請人保證所提供或填寫之資料均為真實及正確無誤（包括個人資料及可供聯絡之住址、電話或電子郵件、帳號、伺服器、角色名稱及查詢時間等等）。若查證所提供之相關證明文件係經偽造、變造，或是所填寫之資料並非真實所致之損失，將由申請人自行承擔；且克里奧數位行銷有限公司將視該申請無效亦不接受退款；倘若情節重大者或涉及不正行為，則克里奧數位行銷有限公司有權直接將申請人之相關資料移送檢警調單位，以追究申請人應負之刑責。
          </li>
          <li>克里奧數位行銷有限公司提供之測試伺服器或於遊戲推廣期間（封測、公測），將不受理各服務相關申請。</li>
          <li>申請各服務項目，必須於事實發生後三十日內向本公司申請查核，超過限定時間者恕不接受查核，您的既有損失，本公司亦無法賠償。</li>
        </ol>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十、用戶資料處理與隱私權保護</h2>
      <div class="section-content">
        <p>
          對於用戶所登錄或留存之個人資料，您同意克里奧數位行銷有限公司得於合理之範圍內保存、蒐集、處理、傳遞及使用用戶個人資料或其衍生之相關電磁記錄，以提供用戶其他資訊服務，或作成用戶統計資料、進行關於網路行為之調查或研究或為任何之合法使用。對於用戶所登錄或留存之個人資料，克里奧數位行銷有限公司在未獲用戶同意之前，不對外揭露用戶之姓名、地址、電子郵件地址及其他依法受保護之個人資料，但下列情況不在此限：
        </p>
        <ol class="numbered-list">
          <li>受司法、警察或其他有權機關基於法定程序之要求時。</li>
          <li>於維護公益或保護克里奧數位行銷有限公司或他人權益時。</li>
          <li>因用戶之行為違反法令或本服務條款之規定時。</li>
          <li>在緊急情況下為維護其他用戶或第三人之人身、交易內容、遊戲歷程、個人資料之完整安全時。</li>
        </ol>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十一、契約之終止及退費</h2>
      <div class="section-content">
        <p>
          用戶得隨時通知克里奧數位行銷有限公司終止本契約，用戶於七日期限內得向克里奧數位行銷有限公司請求退還相當之款項。但該款項應扣除一定比例之手續費後，於三十日內將用戶未使用之遊戲點數以現金、信用卡、匯票或掛號寄發支票方式退還用戶未使用之儲值或遊戲費用。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十二、智慧財產權</h2>
      <div class="section-content">
        <p>
          此服務平台上之所有著作及資料，其著作權、專利權、商標、營業秘密、其他智慧財產權，所有權或其他權利，均為克里奧數位行銷有限公司或其權利人所有，除事先經克里奧數位行銷有限公司或其各別權利人之合法授權外，用戶不得擅自以重製、傳輸、改作、編輯或以其他任何形式、基於任何目的加以使用，違者應自行負所有相關法律責任。前項情形，會員亦不得對於因持有或占有克里奧數位行銷有限公司遊戲網站上之所有著作及資料而為移轉、買賣、讓與或其他處分之行為。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十三個別條款之效力</h2>
      <div class="section-content">
        <p>本同意書所定之任何用戶條款之全部或部分無效時，不影響其他條款之效力。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十四、準據法</h2>
      <div class="section-content">
        <p>
          本服務條款之解釋及適用，以及用戶因使用本服務而與克里奧數位行銷有限公司間所生之權利義務關係，應依中華民國法律解釋適用之（不含涉外民事法律適用法或其他類似法規。）
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十五、管轄法院</h2>
      <div class="section-content">
        <p>
          因本服務條款而生之爭議，均同意以臺灣士林地方法院為第一審管轄法院；前項約定不排除消費者保護法第四十七條或民事訴訟法第四三六條之九小額訴訟管轄法院之適用。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.protocol-container {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.protocol-header {
  text-align: center;
  padding: 20px 0 30px;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 24px;
}

.protocol-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: 2px;
}

.protocol-intro {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  p {
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    margin: 0 0 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.protocol-section {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1890ff;
    margin: 0 0 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e8e8e8;
  }

  .section-content {
    p {
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      margin: 0 0 12px;
      text-align: justify;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .sub-section {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .sub-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin: 0 0 10px;
      }
    }

    .numbered-list {
      margin: 12px 0;
      padding-left: 24px;

      li {
        font-size: 14px;
        line-height: 1.8;
        color: #333;
        margin-bottom: 8px;
        text-align: justify;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
